import i18n from '../plugins/i18n'

import { localstorageStore } from '../plugins/localforage'

export const favorites = {
  state: {
    favorites: [],
  },

  mutations: {
    setFavorites(state, favorites) {
      state.favorites = favorites
    },
  },

  actions: {
    fetchFavoritesFromLocal({ commit, dispatch }) {
      return new Promise(async (resolve, reject) => {

        try {
          const favorites = await localstorageStore.getItem('favorites')

          if (!favorites) {

            commit('setFavorites', [])
            await dispatch('storeFavoritesToLocal', [])
            return resolve()
          }

          const parsedFavorites = JSON.parse(favorites)

          commit('setFavorites', parsedFavorites)

          return resolve(parsedFavorites)
        } catch (err) {
          commit('setFavoritesError', 'errors.favorites.fetch')
          return reject()
        }
      })
    },

    async storeFavoritesToLocal({ commit }, favorites) {
      return new Promise(async (resolve, reject) => {
        try {
          const stringifiedFavorites = JSON.stringify(favorites)

          await localstorageStore.setItem('favorites', stringifiedFavorites)

          resolve()
        } catch (err) {
          commit('setFavoritesError', 'errors.favorites.store')
          reject()
        }
      })
    },

    async addFavorite({ state, dispatch, commit }, poi) {
      const { favorites } = state

      favorites.push(poi.id)

      commit('setFavorites', favorites)
      await dispatch('storeFavoritesToLocal', favorites)
    },

    async removeFavorite({ state, dispatch, commit }, poi) {
      const { favorites } = state

      const filteredFavorites = favorites.filter((id) => id !== poi.id)

      commit('setFavorites', filteredFavorites)
      await dispatch('storeFavoritesToLocal', filteredFavorites)
    },

    async clearFavorites({ commit, dispatch }) {
      commit('setFavorites', [])
      await dispatch('storeFavoritesToLocal', [])
    },
  },

  getters: {
    sharingUrl: (state, getters, rootState) => {
      const { locale } = rootState

      let parameters = ''
      for (let id of state.favorites) {
        parameters += `ids[]=${id}&`

      }
      parameters = parameters.slice(0, -1)

      const { origin } = window.location

      const slug = i18n.t('router.my-venues')

      const url = `${origin}/${locale}/${slug}?${parameters}`

      return url
    },
  },
}
